import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  artistInitialValues,
  ArtistTabs,
} from 'components/organisms/forms/artist/ArtistForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiUserPlus, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostArtist } from 'services/artists';
import { useAddArtistImage } from 'services/artists/images';
import { useCreateProfilePicture } from 'services/artists/profilePicture';
import { IArtistMutationForm } from 'services/artists/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getLastPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateArtist = () => {
  const createArtist = usePostArtist();
  const createProfilePicture = useCreateProfilePicture();
  const addImage = useAddArtistImage();

  const { t } = useTranslation();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const mutateOptions = useMutateOptions<IArtistMutationForm>();

  const goToDetail = (id: string) =>
    navigate(`/artist/${id}/${getLastPathname(pathname)}`);

  const onSuccessCreatePicture = async (file: File, id: string) => {
    await createProfilePicture.mutateAsync(
      {
        id: id,
        file: file,
      },
      {
        // onSuccess: () => goToDetail(id),
        onError: error => {
          onErrorShowAllErrorsToast(error);
          // goToDetail(id);
        },
      }
    );
  };

  const onCreateArtist = async (
    values: IArtistMutationForm,
    helpers: FormikHelpers<IArtistMutationForm>
  ) => {
    const artist = middleware.artist.formToQuery(values);

    await createArtist.mutateAsync(artist, {
      ...mutateOptions(helpers),
      onSuccess: async data => {
        if (values.file) {
          await onSuccessCreatePicture(values.file, data.id);
        }

        if (values.gallery.pendingImages.length > 0) {
          await Promise.all(
            values.gallery.pendingImages.map(file =>
              addImage.mutateAsync({
                file,
                id: data.id,
                isMain: true,
              })
            )
          );
        }

        goToDetail(data.id);
      },
    });
  };

  return (
    <Form.Artist
      i18nextPrefix='artist'
      initialValues={artistInitialValues}
      onSubmit={onCreateArtist}
      customBackItem={
        <Button onlyIcon onClick={() => navigate('/artist')}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
          <Button.Icon icon={<PiUserPlus />} />
        </Button>
      }
      disableTabs={[
        ArtistTabs.bio,
        ArtistTabs.actions,
        ArtistTabs.products,
        ArtistTabs.tracks,
        ArtistTabs.duplicates,
      ]}
    />
  );
};

export default CreateArtist;
